import React from 'react';
import { Modal, ModalFooter, ModalBody, ModalHeader, Button, Input, InputGroup, InputGroupText} from 'reactstrap';
import SearchResultsList from '../person/SearchResultsList';
import { debounce } from 'debounce';

class Search extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            disableContactAddButton: true
        };
    }
           
    handleSearchChange = (e) => this.throttledSearch(e.currentTarget.value);

    throttledSearch = debounce((searchTerm) => this.props.onSearch(searchTerm), 500);

    handleSelectionChanged = (selected) => this.selected = selected;

    handleAdd = () => {
        this.props.onAdd(this.selected);
        this.setState({ disableContactAddButton: true })
    }

    updateDisableAddButton = (value) => {
        this.setState({ disableContactAddButton:value })
    }

    render() {
        return (
            <Modal
                isOpen={this.props.isOpen}
                toggle={this.props.toggle}
                size='lg'
                scrollable={true}
            >
                <ModalHeader toggle={this.props.toggle}>Point of Contact Search</ModalHeader>
                <ModalBody>
                    <InputGroup className='pb-1'>
                        <InputGroupText>Search:</InputGroupText>
                        <Input type='text' onChange={this.handleSearchChange} />
                    </InputGroup>
                    <SearchResultsList
                        updateDisableAddButton={this.updateDisableAddButton}
                        data={this.props.data}
                        onSelectionChanged={this.handleSelectionChanged}
                    />
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" disabled={this.state.disableContactAddButton} onClick={this.handleAdd}>Add</Button>{' '}
                    <Button color="secondary" onClick={this.props.toggle}>Cancel</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

export default Search